import { render, staticRenderFns } from "./ColumnsStep.vue?vue&type=template&id=29084e00&scoped=true&"
import script from "./ColumnsStep.vue?vue&type=script&lang=js&"
export * from "./ColumnsStep.vue?vue&type=script&lang=js&"
import style0 from "./ColumnsStep.vue?vue&type=style&index=0&id=29084e00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29084e00",
  null
  
)

export default component.exports